import { UrlStatus as UrlApiStatus } from "../useAddExternalItemsWorkflow/useUrlVerificationNotificationsSubscription";

import {
  type AlreadyAddedUrlData,
  type UrlData,
  UrlLocalStatus,
} from "./types";

export function urlVerificationPending(urlData: UrlData): boolean {
  return urlData.status === UrlLocalStatus.pending;
}

export function urlCanBeAdded(urlData: UrlData): boolean {
  return urlData.status === UrlApiStatus.canBeAdded;
}

export function urlAlreadyAdded(
  urlData: UrlData
): urlData is AlreadyAddedUrlData {
  return urlData.status === UrlApiStatus.alreadyAdded;
}
